export default __webpack_public_path__ + "static/media/sohlLogo.021c96ad.svg";